/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    import IMessageTranslation = Models.IMessageTranslation;
    import IMessageTranslationMap = Models.IMessageTranslationMap;
    import IPaginatedList = Models.IPaginatedList;
    import HalConverter = Models.HalConverter;
    import IHalList = Models.IHalList;

    export class MessageTranslationsService {
        public static $name: string = "messageTranslationsService";
        public static $inject: string[] = ['$q', '$http', '$rootScope'];
        public static placeHolder: string = '%s';

        public mssgs: IMessageTranslationMap = {};

        private backendBaseUrl: string = window.backendUrl;
        private serviceUrl: string = this.backendBaseUrl + 'messageTranslations/';
        private currentUserUrl: string = this.backendBaseUrl + 'currentUser';
        private currentUser: Models.User;

        constructor(private $q: ng.IQService,
                    private $http: ng.IHttpService,
                    private $rootScope: ng.IRootScopeService) {
            this.$rootScope.$on('vars.isUserLoggedIn', (event: ng.IAngularEvent, args: boolean) => {
                this.getAllMessages();
            });
        }

        public showPromiseError(reason: ngCustom.IReason): void {
            Common.Utils.closeStickyAlerts();
            this.loadCurrentUser().then((user: Models.User) => {
                if (user.username === 'demiurgo') {
                    if (reason !== undefined) {
                        if (reason.status === 404)
                            this.alertOnError('promise.error.404', 'bottom-center');
                        else if (reason.status === 401)
                            this.alertOnError('promise.error.401', 'bottom-center');
                        else if (reason.status === 403)
                            this.alertOnError('promise.error.403', 'top-center');
                        else if (reason.data && reason.data.message)
                            this.alertOnError('promise.error.data.message', 'bottom-center', reason.data.message);
                        else if (reason.data && reason.data.error)
                            this.alertOnError('promise.error.data.error', 'bottom-center', reason.data.error);
                        else
                            this.alertOnError('promise.error.status', 'bottom-center', String(reason.status) );
                    } else {
                        this.alertOnError('promise.error.generic', 'bottom-center');
                    }
                } else {
                    console.log(reason);
                }
            });

        }

        public alertOnError( message: string, position?: string, ...params: string[] ): void {
            this.getMessageAsStringByKey(message, ...params).then((translatedMessage: string) => {
                    Common.Utils.alertOnError(translatedMessage, position);
                });
        }

        public getMessageAsStringByKey(key: string, ...params: string[]): ng.IPromise<string> {
            let deferred: ng.IDeferred<string> = this.$q.defer();
            if (this.mssgs[key] !== undefined) {
                let response: string = this.mssgParamsReplacement(this.mssgs[key].description, ...params);
                deferred.resolve(response);
            } else {
                this.$http.get(this.serviceUrl + '/search/findByKey?key=' + key).then((mssg: IMessageTranslation) => {
                    this.mssgs[key] = mssg;
                    let response: string = this.mssgParamsReplacement(mssg.description, ...params);
                    deferred.resolve(response);
                }).catch((reason: ngCustom.IReason) => {
                    deferred.resolve(key);
                });
            }
            return deferred.promise;
        }

        /**
         * Sync method to retrieve the message string, to avoid adding too much code in some places
         */
        public getMessageAsStringByKeySync( key: string, params?: string[] ): string {
            if (this.mssgs[key] !== undefined) {
                if (params && params.length > 0) {
                    params.unshift(this.mssgs[key].description);
                    return this.mssgParamsReplacement.apply(this, params);
                }
                return this.mssgs[key].description;
            }
            return key;
        }

        public getAllMessages(): ng.IPromise<IMessageTranslation[]> {
            if ( Object.keys(this.mssgs).length > 0 ) {
                let deferred: ng.IDeferred<IMessageTranslation[]> = this.$q.defer();
                let response: IMessageTranslation[] = [];
                for (let key in this.mssgs) {
                    if (this.mssgs.hasOwnProperty(key)) {
                        response.push(this.mssgs[key]);
                    }
                }
                deferred.resolve(response);
                return deferred.promise;
            } else {
                return this.$http.get(this.serviceUrl + '?size=9999').then(
                    (response: ng.IHttpPromiseCallbackArg<IHalList<IMessageTranslation>>) => {
                        let convertedList: IPaginatedList<IMessageTranslation>;
                        convertedList = HalConverter.convertPaginatedList(response.data, Models.MessageTranslation.Empty);
                        for (let mssg of convertedList.elements) {
                            let key: string = mssg.key;
                            this.mssgs[key] = mssg;
                        }
                        return convertedList.elements;
                    });
            }
        }

        public updateMessage( message: IMessageTranslation ): ng.IPromise<IMessageTranslation> {
            return this.$http
                .put(message.href, {
                    key: message.key,
                    description: message.description,
                    params: message.params,
                    lastUserUpdated: message.lastUserUpdated,
                })
                .then((result: ng.IHttpPromiseCallbackArg<IMessageTranslation>) => {
                    return result.data;
                });
        }

        private mssgParamsReplacement(mssg: string, ...params: string[]): string {
            if (!mssg || !params || params.length <= 0)
                return mssg;
            for (let param of params) {
                mssg = mssg.replace(MessageTranslationsService.placeHolder, param);
            }
            return mssg;
        }

        private loadCurrentUser(): Promise<Models.User> {
            if (this.currentUser) {
                return new Promise<Models.User>((resolve: Function, reject: Function) => {
                    resolve(this.currentUser);
                });
            } else {
                return this.$http.get(this.currentUserUrl)
                    .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.User>>) => {
                        this.currentUser = HalConverter.convertElement(result.data, Models.User.createEmpty);
                        return this.currentUser;
                    });
            }
        }
    }
}